import { render } from "./Strategie.vue?vue&type=template&id=3fb5a65a"
import script from "./Strategie.vue?vue&type=script&lang=js"
export * from "./Strategie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__